var _rect, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 172,
    viewBox: "0 0 173 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 172,
    height: 172,
    rx: 86,
    fill: "#F4FFF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5004 143.6C101.777 143.6 116.428 137.532 127.23 126.73C138.032 115.928 144.1 101.277 144.1 86.0004C144.1 70.7239 138.032 56.0731 127.23 45.271C116.428 34.4689 101.777 28.4004 86.5004 28.4004C71.2239 28.4004 56.5731 34.4689 45.771 45.271C34.9689 56.0731 28.9004 70.7239 28.9004 86.0004C28.9004 101.277 34.9689 115.928 45.771 126.73C56.5731 137.532 71.2239 143.6 86.5004 143.6ZM113.191 76.6908C114.502 75.3329 115.228 73.5141 115.212 71.6263C115.195 69.7385 114.438 67.9326 113.103 66.5977C111.768 65.2628 109.962 64.5055 108.074 64.4891C106.187 64.4727 104.368 65.1985 103.01 66.51L79.3004 90.2196L69.9908 80.91C68.6329 79.5985 66.8141 78.8727 64.9263 78.8891C63.0385 78.9055 61.2326 79.6628 59.8977 80.9977C58.5628 82.3326 57.8055 84.1385 57.7891 86.0263C57.7727 87.9141 58.4985 89.7329 59.81 91.0908L74.21 105.491C75.5602 106.841 77.3912 107.599 79.3004 107.599C81.2096 107.599 83.0406 106.841 84.3908 105.491L113.191 76.6908Z",
    fill: "#37A372"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 52,
    r: 9.5,
    fill: "#37A372",
    stroke: "#F4FFF5",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.21fef8df6a604ec606a5e374ee6b3103.svg";
export { ForwardRef as ReactComponent };